var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"err-page-wrap"},[_c('div',{staticClass:"err-img"},[_c('img',{attrs:{"src":_vm.errImg,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("网络加载失败，请点击返回")]),_vm._v(" "),_c('mt-button',{staticClass:"button",attrs:{"type":"default"},on:{"click":_vm.back}},[_vm._v("返回")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b521853","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/electronicLetter/common/errPage.vue
// module id = null
// module chunks = 